module.exports = __webpack_public_path__ + "img/Event_Icon_News_White.7f66cff0.png";